import { useState, useEffect, useRef, forwardRef } from 'react';
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { Container, Card, Group, Text, ActionIcon, Button, Menu, Modal, Input, Space, MultiSelect, Skeleton, Flex, useMantineTheme } from '@mantine/core';
import { IconSettings, IconHelp, IconX, IconCheck } from '@tabler/icons-react';
import './Funnel.css';
import ReactDOM from 'react-dom';
import { modals } from '@mantine/modals';
import { useNavigate } from "react-router-dom";
import { SelectFunnelList, SelectTooltip, VisiLoader, showWpSyncWarning } from "../../components/GeneralComponent/GeneralComponent";
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import PermissionWrapper from '../../PermissionWrapper';
import FunnelApi from "../../api/FunnelApi";
import { AddUpdateFunnel } from "../../components/Funnel/AddUpdateFunnel";
import { FunnelData } from "../../components/Funnel/FunnelData";
import { FunnelLegend } from "../../components/Funnel/FunnelLegend";
import { AddButtonToFunnel } from "../../components/Funnel/AddButtonToFunnel";
import { BlockIP } from "../../components/Funnel/BlockIP";
import { AddFunnelPage } from "../../components/Funnel/AddFunnelPage";
import { DuplicateFunnel } from "../../components/Funnel/DuplicateFunnel";
import { UniversalSmartCodeModal } from "../../components/Settings/ManageYourDomains/UniversalSmartCodeModal";
import { useAuth } from '../../AuthContext';

export function Funnel() {

  const navigate = useNavigate();
  const theme = useMantineTheme();
  const isDarkMode = theme.colorScheme === 'dark';
  const { websiteListData } = useAuth();
  useDocumentTitle("Visiopt - Funnel");

  const editPageRef = useRef(null);
  const visismartCodeRef = useRef(null);
  const settingsIconRef = useRef(null);
  const editTitleRef = useRef(null);
  const funnelsIconRef = useRef(null);
  const mergePageRef = useRef(null);
  const ignorePageRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  const [SelectedFunnelValue, setSelectedFunnelValue] = useState(null);
  const [selectedFunnelTitle, setselectedFunnelTitle] = useState('');
  const [SystemUsageLoader, setSystemUsageLoader] = useState(false);
  const [PageTimeout, setPageTimeout] = useState('');
  const [FlickerControl, setFlickerControl] = useState('');
  const [editPageDetail, setEditPageDetail] = useState({name: '',url: ''});
  const [selectedPageId, setSelectedPageId] = useState(null);
  const [settingModalOpen, setSettingModalOpen] = useState(false);
  const [marksalestime, setMarksalestime] = useState(0);
  const [updatedtime, setUpdatedtime] = useState(0);
  const [selectedOption, setSelectedOption] = useState({});
  const [editPageModalOpen, setEditPageModalOpen] = useState(false);
  const [data, setData] = useState({ edit_funnel_name: '' });
  const [customtitle, setCustomTitle] = useState({ name: '' });
  const [customtitlepageid, setCustomTitlePageId] = useState({ pageId: ''});
  const [settingdata, setSettingData] = useState({ savepagetimeout: '',saveflickercontrol:'' });
  const [visiSmartCodeModalOpen, setVisiSmartCodeModalOpen] = useState(false);
  const [visiSmartCodePageId, setVisiSmartCodePageId] = useState<string>('');
  const [checkTracking, setCheckTracking] = useState('');
  const [checkTrackingModelOpen, setcheckTrackingCloseModal] = useState(false);
  const [editTitleModelOpen, setEditTitleModelOpen] = useState(false);
  const [selectedThumbnails, setSelectedThumbnails] = useState([]);
  const [handleEditFunnelOpenModalProp, sethandleEditFunnelOpenModalProp] = useState(false);
  const [handleAddbuttonFunnelOpenModalProp, sethandleAddbuttonFunnelOpenModalProp] = useState(false);
  const [handleBlockIPOpenModalProp, sethandleBlockIPOpenModalProp] = useState(false);
  const [handleSelectPageOpenModalProp, sethandleSelectPageOpenModalProp] = useState(false);
  const [afterAddNewPage, setAfterAddNewPage] = useState(0);
  const [Avoidextracall, setAvoidextracall] = useState(0);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({});
  const [ignorePagesModalOpen, setIgnorePagesModalOpen] = useState(false);
  const [ignorePagesList, setIgnorePagesList] = useState([]);
  const [ignorePagesValue, setIgnorePagesValue] = useState<string[]>([]);
  const [ignorePagesId, setIgnorePagesId] = useState('');
  const [mergePageModalOpen, setMergePageModalOpen] = useState(false);
  const [mergePagesList, setMergePagesList] = useState([]);
  const [mergePagesValue, setMergePagesValue] = useState<string[]>([]);
  const [mergeOriginUrl, setMergeOriginUrl] = useState<string>('');
  const [mergePagesLoading, setMergePagesLoading] = useState<boolean>(false);
  const [ignorePagesLoading, setIgnorePagesLoading] = useState<boolean>(false);
  const [removedLinks, setRemovedLinks] = useState([]);
  const [mergePagesId, setMergePagesId] = useState('');
  const [duplicateFunnelModalOpen, setDuplicateFunnelModalOpen] = useState(false);

  const handleHeaderMenuComponentChange = (Value:any) => {
    setSelectedMemberWebsite(Value);
  };

  const handleSelectFunnelListComponentChange = (Value:any) => {
    setAvoidextracall(Avoidextracall+1);
    setSelectedFunnelValue(Value);
  };

  /*Use All Funnel Form Name*/
  const form = useForm({
    initialValues: {
      funnel_name: '',
      edit_funnel_name: '',
      blockipaddress: '',
      savepagetimeout: '',
      saveflickercontrol:'',
      url: ''
    },
  });

  /*Rename Edit Funnel*/
  const handleEditFunnelOpenModal = (value:any) => {
    sethandleEditFunnelOpenModalProp(value);
  };

  useEffect(() => {
    if (selectedFunnelTitle) {
      setData(prevData => ({ ...prevData, edit_funnel_name: selectedFunnelTitle }));
    }
  }, [selectedFunnelTitle]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  /*Delete Funnel*/
  const deleteFunnelConfirm = async (selectedMemberWebsite:any) => {
    try {
      const APIResponse = await FunnelApi.deletefunnel({
        system_website_id: selectedMemberWebsite,
        alert_check:1
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.message === '' && APIResultJSON.status === 0) {
        modals.openConfirmModal({
          trapFocus: false,
          title: 'Delete the Funnel',
          children: (
            <Text size="sm">
              Are you sure you want to delete this funnel?
            </Text>
          ),
          labels: { confirm: 'Delete the Funnel', cancel: "No don't delete it" },
          confirmProps: { color: 'red' },
          onCancel: () => console.log('Cancel'),
          onConfirm: async () => {
            try {
              const APIResponse = await FunnelApi.deletefunnel({
                system_website_id: selectedMemberWebsite,
                alert_check:0
              });
              const APIResultJSON = await APIResponse.json();
              if (APIResultJSON.status === 1) {
                notifications.show({
                  color: 'green',
                  icon: <IconCheck size="1.1rem" />,
                  title: 'Success',
                  message: APIResultJSON.message,
                })
                setUpdatedtime(APIResultJSON.data.updated_time);
                handleSelectFunnelListComponentChange(APIResultJSON.data.selected_funnel_id);
              } else {
                notifications.show({
                  color: 'red',
                  icon: <IconX size="1.1rem" />,
                  title: 'Error',
                  message: APIResultJSON.message,
                })
              }
            } catch (error) {
              console.log('Error Something Went Wrong', error);
            }
          },
        });
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  /*Get Page in Add Button To The Funnel*/
  const handleAddbuttonFunnelOpenModal = () => {
    sethandleAddbuttonFunnelOpenModalProp(true);
  };

  /*Get Block IP Address*/
  const handleBlockIPOpenModal = () => {
    sethandleBlockIPOpenModalProp(true);
  };

  /*Get Page Timeout*/
  const handleSettingOpenModal = (selectedPageId) => {
    setSelectedPageId(selectedPageId);
    setSettingModalOpen(true);
    FunnelApi.getpagetimeout({
      system_website_id: selectedMemberWebsite,
      page_id: selectedPageId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
            navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data) {
        setPageTimeout(data.data.visiopt_timeout);
        setFlickerControl(data.data.flicker_control);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const handleSettingCloseModal = () => {
    setSettingModalOpen(false);
  };

  /*Merge Pages*/
  const handleMergePageOpenModal = (value:any) => {
    setMergePageModalOpen(true);
    setMergePagesId(value);
    setMergePagesList([]);
    setMergePagesValue([]);
    setMergePagesLoading(true);
    FunnelApi.getmergepageslist({
      system_website_id: selectedMemberWebsite,
      page_id:value
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setMergePagesList(data.data);
        const selectedOptions = data.data
          .filter((option) => option.selected === "true")
          .map((option) => option.link_id);
        setMergePagesValue(selectedOptions);
      } else {
        setMergePagesValue([]);
      }
      setMergePagesLoading(false);
    })
    .catch(error => {
      console.error("API Error:", error);
      setMergePagesLoading(false);
    });
  };

  const handleMergePagesChange = (value) => {
    const removed = mergePagesValue.filter(link => !value.includes(link));
    const decodeHtml = (str: string) => {
      const txt = document.createElement('textarea');
      txt.innerHTML = str ?? '';
      return txt.value;
    };
    const lockedRemoved = removed.filter(link => {
      const opt = mergePagesList.find(o => o.link_id === link);
      return opt && mergeOriginUrl !== '' && decodeHtml(opt.page_url) === decodeHtml(mergeOriginUrl);
    });
    if (lockedRemoved.length > 0) {
      return;
    }
    setRemovedLinks(prevRemoved => [...prevRemoved, ...removed]);
    const hasActivePage = mergePagesList.some(
      page => value.includes(page.link_id) && page.page_type === "2"
    );
    if (hasActivePage) {
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "You can't merge pages with active tests.",
      });
      return;
    }
    const allLinks = [[
      {"page_id": mergePagesId},
      {"links": value.join(',')}
    ]];
    FunnelApi.checkmergepagesvalidation({
      system_website_id: selectedMemberWebsite,
      all_page_links_check:allLinks
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setMergePagesValue(value);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const handleSaveMergePages = (e) => {
    e.preventDefault();
    const allPageLinks = [[
      {"page_id": mergePagesId},
      {"links": mergePagesValue.join(',')},
      {"removelinks": removedLinks.join(',')}
    ]];
    FunnelApi.savemergepages({
      system_website_id: selectedMemberWebsite,
      page_id:mergePagesId,
      all_page_links:allPageLinks
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setRemovedLinks([]);
        handleMergePageCloseModal();
        setMarksalestime(data.data.updated_time);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }

  const handleMergePageCloseModal = () => {
    setMergePageModalOpen(false);
    setRemovedLinks([]);
  };
  

  useEffect(() => {
    if (PageTimeout || FlickerControl) {
      setSettingData(prevSettingData => ({ ...prevSettingData, savepagetimeout: PageTimeout, saveflickercontrol:FlickerControl  }));
    }
  }, [PageTimeout,FlickerControl]);

  const handleChangePageTime = (e) => {
    setSettingData({ ...settingdata, savepagetimeout: e.target.value });
  };

  const handleChangeFlickerControl = (e) => {
    setSettingData({ ...settingdata, saveflickercontrol: e.target.value });
  };

  /*Save Page Timeout*/
  const handleSavePageTimeoutSubmit = async (formData:any) => {
    setSelectedPageId(selectedPageId);
    FunnelApi.savepagetimeout({
      page_id: selectedPageId,
      visiopt_timeout: settingdata.savepagetimeout,
      flicker_control: settingdata.saveflickercontrol
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        if(data.data.msg === ""){
          notifications.show({
            color: 'green',
            icon: <IconCheck size="1.1rem" />,
            title: 'Success',
            message: data.message,
          });
          setMarksalestime(data.updated_time);
          handleSettingCloseModal();
        } else {
          modals.open({
            title: 'Message',
            children: (
            <>
              <Text size="sm">
                {data.data.msg}
              </Text>
              <Group position="right" mt="md">
                <Button onClick={() => {
                  modals.closeAll();
                  setVisiSmartCodePageId(selectedPageId);
                  setVisiSmartCodeModalOpen(true);
                }}>OK</Button>
              </Group>
            </>
            ),
          });
          setMarksalestime(data.updated_time);
          handleSettingCloseModal();
        }
      } else {
        form.setErrors({ savepagetimeout: data.message });
        form.setErrors({ saveflickercontrol: data.message });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }

  /*Edit Page Detail*/
  const handleEditOpenModal = (selectedPageId) => {
    setSelectedPageId(selectedPageId);
    setEditPageModalOpen(true);
    FunnelApi.getpagedetail({
      page_id: selectedPageId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data) {
        setEditPageDetail(data.data);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const handleEditCloseModal = () => {
    setEditPageModalOpen(false);
  };

  useEffect(() => {
    if (editPageDetail) {
      setEditPageDetail(editPageDetail);
    }
  }, [editPageDetail]);

  const handleChangeEditPage = (e) => {
    const { name, value } = e.target;
    setEditPageDetail({ ...editPageDetail, [name]: value });
  };

  const handleEditPageSubmit = async (formData :any) =>  {
    try {
      const APIResponse = await FunnelApi.editpage({
        system_website_id: selectedMemberWebsite,
        page_id: selectedPageId,
        name : editPageDetail.name,
        url : editPageDetail.url
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.status === 1) {
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: APIResultJSON.message,
        });
        showWpSyncWarning(APIResultJSON, selectedMemberWebsite);
        setMarksalestime(APIResultJSON.data.updated_time);
        handleEditCloseModal();
      } else {
        form.setErrors({ url: APIResultJSON.message });
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const handleRecordConversion = async (selectedPageId) => {
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.marksalesconversion({
        page_id: selectedPageId,
        system_website_id : selectedMemberWebsite
      });
       const APIResultJSON = await APIResponse.json();
        setMarksalestime(APIResultJSON.data.updated_time);
      if (APIResultJSON.status === 1) {
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleUnsetwinner = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.unsetwinner({
        page_id: selectedPageId,
        system_website_id : selectedMemberWebsite
      });
       const APIResultJSON = await APIResponse.json();
        setMarksalestime(APIResultJSON.data.updatedtime);
      if (APIResultJSON.status === 1) {
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleRemoveFromfunnel = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.removefromfunnel({
        page_id: selectedPageId,
        system_website_id : selectedMemberWebsite,
        alert_check:1
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.message === '' && APIResultJSON.status === 0) {
        const isDataEmpty =
          !APIResultJSON.data ||
          (Array.isArray(APIResultJSON.data) && APIResultJSON.data.length === 0) ||
          (typeof APIResultJSON.data === 'object' &&
            !Array.isArray(APIResultJSON.data) &&
            Object.keys(APIResultJSON.data).length === 0);
        if (isDataEmpty) {
          modals.openConfirmModal({
            trapFocus: false,
            title: 'REMOVE FROM FUNNEL',
            children: (
              <Text size="sm">
                Are you sure you want to remove this page from the Funnel?
              </Text>
            ),
            labels: {
              confirm: 'Remove from Funnel',
              cancel: "No don't Remove it",
            },
            confirmProps: { color: 'red' },
            onCancel: () => console.log('Cancel'),
            onConfirm: () => {
              handleRemoveFromfunnelAlertCheck(selectedPageId);
            },
          });
          return;
        }
        const RemoveFromFunnelConfirmation = () => {
          const [removeValue, setRemoveValue] = useState('');
          const [error, setError] = useState('');
          let message = '';
          if (APIResultJSON.data?.campaign_active === '1') {
            message = `This Page Is Currently In Use
            This page is being used as a conversion/goal page in an active campaign and is connected to Conversion API tracking.
            
            Removing it will:
            • stop tracking conversions/goal for this page  
            • break reporting and attribution for the affected campaign(s)  
            • permanently remove associated conversion data  
            This action cannot be undone.
            Are you sure you want to continue?`;
          } else if (APIResultJSON.data?.test_active === '1') {
            message = 'This is a conversion page in a test. Are you sure you want to remove this page?';
          } else if (APIResultJSON.data?.both_active === '1') {
            message = `This Page Is Currently In Use
            This page is being used in both an active test and an active campaign.

            Removing it will:
            • stop tracking conversions/goal for this page  
            • break reporting and attribution for the affected campaign(s)  
            • impact active test performance and results  
            This action cannot be undone.
            Are you sure you want to continue?`;
          }
          const handleConfirmRemove = () => {
            if (removeValue.trim() === 'REMOVE') {
              modals.closeAll();
              handleRemoveFromfunnelAlertCheck(selectedPageId);
            } else {
              setError('Word does not match.');
            }
          };

          return (
            <>
              <Text size="sm" style={{ userSelect: 'none', whiteSpace: 'pre-line' }}>
                {message}
                {'\n\n'}
                To proceed, enter <b>REMOVE</b> below:
              </Text>
              <Input
                mt={10}
                mb={10}
                value={removeValue}
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  setRemoveValue(value);
                  if (value.trim() === 'REMOVE') {
                    setError('');
                  }
                }}
              />
              {error && (
                <Text color="red" size="sm" mt={10}>
                  {error}
                </Text>
              )}
              <Group position="right">
                <Button onClick={handleConfirmRemove}>OK</Button>
              </Group>
            </>
          );
        };

        modals.open({
          title: 'REMOVE FROM FUNNEL',
          trapFocus: false,
          children: <RemoveFromFunnelConfirmation />,
        });
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  
  const handleRemoveFromfunnelAlertCheck = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.removefromfunnel({
        page_id: selectedPageId,
        system_website_id : selectedMemberWebsite,
        alert_check:0
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.status === 1) {
        handleChooseActionReset('');
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: APIResultJSON.message,
        });
        setMarksalestime(APIResultJSON.data.updatedtime);
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleRemoveButtonFromfunnel = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.removebuttonfromfunnel({
        button_id: selectedPageId,
        system_website_id : selectedMemberWebsite
      });
       const APIResultJSON = await APIResponse.json();
        setMarksalestime(APIResultJSON.data.updatedtime);
      if (APIResultJSON.status === 1) {
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleCheckTrecking = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    setSystemUsageLoader(true);
    try {
      const APIResponse = await FunnelApi.checktracking({
        page_id: selectedPageId,
      });
       const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.status === 1) {
        setSystemUsageLoader(false);
        setMarksalestime(APIResultJSON.data.updatedtime);
        setCheckTracking(APIResultJSON.data.message);
        setcheckTrackingCloseModal(true);
      }else{
        setSystemUsageLoader(false);
        setCheckTracking(APIResultJSON.message);
        setcheckTrackingCloseModal(true);
      }
    } catch (error) {
      console.error("API Error:", error);
      setSystemUsageLoader(false);
    }
  };

  const handleDiscarddraft = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.discarddraft({
        page_id: selectedPageId,
        system_website_id : selectedMemberWebsite
      });
       const APIResultJSON = await APIResponse.json();
        setMarksalestime(APIResultJSON.data.updatedtime);
      if (APIResultJSON.status === 1) {
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleDeletePage = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.deletepage({
        system_website_id: selectedMemberWebsite,
        page_id: selectedPageId,
        alert_check:1
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.message === '' && APIResultJSON.status === 0) {
        const isDataEmpty =
          !APIResultJSON.data ||
          (Array.isArray(APIResultJSON.data) && APIResultJSON.data.length === 0) ||
          (typeof APIResultJSON.data === 'object' &&
            !Array.isArray(APIResultJSON.data) &&
            Object.keys(APIResultJSON.data).length === 0);
        if (isDataEmpty) {
          modals.openConfirmModal({
          trapFocus: false,
          title: 'DELETE PAGE',
          children: (
            <Text size="sm">
              Are you sure you want to remove this page?
            </Text>
          ),
          labels: { confirm: 'Delete the Page', cancel: "No don't Delete it" },
          confirmProps: { color: 'red' },
          onCancel: () => console.log('Cancel'),
          onConfirm: () => { 
            handleDeletePageAlertCheck(selectedPageId);
            handleChooseActionReset('');
            setMarksalestime(APIResultJSON.data.updated_time);
          },
          });
          return;
        }
        const DeletePageConfirmation = () => {
          const [deleteValue, setDeleteValue] = useState('');
          const [error, setError] = useState('');
          let message = '';
          if (APIResultJSON.data?.campaign_active === '1') {
            message = `This Page Is Currently In Use
            This page is being used as a conversion/goal page in an active campaign and is connected to Conversion API tracking.

            Removing it will:
            • stop tracking conversions/goal for this page  
            • break reporting and attribution for the affected campaign(s)  
            • permanently remove associated conversion data  
            This action cannot be undone.
            Are you sure you want to continue?`;
          } else if (APIResultJSON.data?.test_active === '1') {
            message = 'This is a conversion page in a test. Are you sure you want to delete this page?';
          } else if (APIResultJSON.data?.both_active === '1') {
            message = `This Page Is Currently In Use
            This page is being used in both an active test and an active campaign.

            Removing it will:
            • stop tracking conversions/goal for this page  
            • break reporting and attribution for the affected campaign(s)  
            • impact active test performance and results  
            This action cannot be undone.
            Are you sure you want to continue?`;
          }
          const handleConfirmDelete = () => {
            if (deleteValue.trim() === 'DELETE') {
              modals.closeAll();
              handleDeletePageAlertCheck(selectedPageId);
            } else {
              setError('Word does not match.');
            }
          };

          return (
            <>
              <Text size="sm" style={{ userSelect: 'none', whiteSpace: 'pre-line' }}>
                {message}
                {'\n\n'}
                To proceed, enter <b>DELETE</b> below:
              </Text>
              <Input
                mt={10}
                mb={10}
                value={deleteValue}
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  setDeleteValue(value);
                  if (value.trim() === 'DELETE') {
                    setError('');
                  }
                }}
              />
              {error && (
                <Text color="red" size="sm" mt={10}>
                  {error}
                </Text>
              )}
              <Group position="right">
                <Button onClick={handleConfirmDelete}>OK</Button>
              </Group>
            </>
          );
        };
        modals.open({
          title: 'DELETE PAGE',
          trapFocus: false,
          children: <DeletePageConfirmation />,
        });
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleDeletePageAlertCheck = async (selectedPageId) =>{
    setSelectedPageId(selectedPageId);
    try {
      const APIResponse = await FunnelApi.deletepage({
        system_website_id: selectedMemberWebsite,
        page_id: selectedPageId,
        alert_check:0
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.status === 1) {
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: APIResultJSON.message,
        });
        showWpSyncWarning(APIResultJSON, selectedMemberWebsite);
        setMarksalestime(APIResultJSON.data.updated_time);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  /*Save Custom Title*/
  const handleEditTitleOpenModal = (item:any, pageId:any) => {
    setEditTitleModelOpen(true);
    setCustomTitle({ ...customtitle, name: item });
    setCustomTitlePageId({ ...customtitlepageid, pageId: pageId });
  };

  const handleChangeCustomTitle = (e) => {
    setCustomTitle({ ...customtitle, [e.target.name]: e.target.value });
  };

  const handleSaveCustomTitleSubmit = async (formData:any, pageId:any) =>{
    try {
      const APIResponse = await FunnelApi.savecustomtitle({
        system_website_id: selectedMemberWebsite,
        page_id: customtitlepageid.pageId,
        custom_title:customtitle.name
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.status === 1) {
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: APIResultJSON.message,
        });
        setMarksalestime(APIResultJSON.data.updated_time);
        handleEditTitleCloseModal();
      } else {
        form.setErrors({ name: APIResultJSON.message });
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const handleEditTitleCloseModal = () => {
    setEditTitleModelOpen(false);
    form.reset();
  };

  /*Select pages from funnel*/
  const handleSelectPageOpenModal = () => {
    sethandleSelectPageOpenModalProp(true);
  };

  const resetSelection = () => {
    setSelectedThumbnails([]);
  };

  const handleCheckTrackingCloseModal = () => {
    setcheckTrackingCloseModal(false);
  };

  const handleChooseActionReset = (event:any) => {
    const result = event.split('==');
    const page_id = result[1];
    setSelectedOption(prevOptions => ({
        ...prevOptions,
        [page_id]: ''
    }));
  };

  const handleChooseActionChange = (event:any) => {
    const result = event.split('==');
    const value = result[0];
    const page_id = result[1];
    setSelectedOption(prevOptions => ({
        ...prevOptions,
        [page_id]: value
    }));
    if(value === "mark_sales"){
      handleRecordConversion(page_id);
      handleChooseActionReset('');
    } else if(value === "edit_page"){
      handleEditOpenModal(page_id);
      handleChooseActionReset('');
    } else if(value === "checkTracking"){
      handleCheckTrecking(page_id);
      handleChooseActionReset('');
    } else if(value === "trackingCode"){
      setAfterAddNewPage(0);
      setVisiSmartCodePageId(page_id);
      setVisiSmartCodeModalOpen(true);
      handleChooseActionReset('');
    } else if(value === "remove"){
      handleRemoveFromfunnel(page_id);
      handleChooseActionReset('');
    } else if(value === "delete"){
      handleDeletePage(page_id);
      handleChooseActionReset('');
    } else if(value === "setting"){
      handleSettingOpenModal(page_id);
      handleChooseActionReset('');
    } else if(value === "ignorePageIds"){
      handleIgnorePagesOpenModal(page_id);
      handleChooseActionReset('');
    } else if(value === "unsetWinner"){
      modals.openConfirmModal({
        trapFocus: false,
        title: 'Unset Winner',
        children: (
          <Text size="sm">
           Are you sure you want to Unset Winner this page?
          </Text>
        ),
        labels: { confirm: 'Unset Winner', cancel: 'Cancel' },
        onCancel: () => console.log('Cancel'),
        onConfirm: () => {
          handleUnsetwinner(page_id);
          handleChooseActionReset('');
        },
      });
    } else if(value === "discardDraft"){
      modals.openConfirmModal({
        trapFocus: false,
        title: 'Discard Draft',
        children: (
          <Text size="sm">
            Are you sure you want to Discard Draft this page?
          </Text>
        ),
        labels: { confirm: 'Discard Draft', cancel: 'Cancel' },
        onCancel: () => console.log('Cancel'),
        onConfirm: () => {
          handleDiscarddraft(page_id);
          handleChooseActionReset('');
        },
      });
    } else if(value === "removebutton"){
      modals.openConfirmModal({
        trapFocus: false,
        title: 'REMOVE FROM FUNNEL',
        children: (
          <Text size="sm">
            Are you sure you want to remove this button from the Funnel?
          </Text>
        ),
        labels: { confirm: 'Remove from Funnel', cancel: "No don't Remove it" },
        confirmProps: { color: 'red' },
        onCancel: () => console.log('Cancel'),
        onConfirm: () => {
          handleRemoveButtonFromfunnel(page_id);
          handleChooseActionReset('');
        },
      });
    } else if(value === "mergePages"){
      handleMergePageOpenModal(page_id);
      handleChooseActionReset('');
    }
  };
  const handleVisiSmartCodeCloseModal = () => {
    setVisiSmartCodeModalOpen(false);
    if(afterAddNewPage === 1){
      handleSelectPageOpenModal();
    }
  };
  const handleEditPageCloseModal = () => {
    setEditPageModalOpen(false);
    form.reset();
  };

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    const refIconMapping = {
      5: funnelsIconRef,
      194: editTitleRef,
      327: settingsIconRef,
      188: visismartCodeRef,
      195: editPageRef,
      115: mergePageRef,
      349: ignorePageRef
    };
    let iconRef = refIconMapping[id];
    if (iconRef.current) {
      const { top, left, width } = iconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        [id]: { top: top + scrollOffset, left: left + width + 10 },
      });
    }
  };

  /* IGNORE PAGES */
  const handleIgnorePagesOpenModal = (value:any) => {
    setIgnorePagesModalOpen(true);
    setIgnorePagesId(value);
    setIgnorePagesList([]);
    setIgnorePagesValue([]);
    setIgnorePagesLoading(true);
    FunnelApi.getignorepageslist({
      system_website_id: selectedMemberWebsite,
      page_id:value
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setIgnorePagesList(data.data);
        const selectedOptions = data.data
          .filter((option) => option.selected === "true")
          .map((option) => option.page_id);
        setIgnorePagesValue(selectedOptions);
      } else {
        setIgnorePagesValue([]);
      }
      setIgnorePagesLoading(false);
    })
    .catch(error => {
      console.error("API Error:", error);
      setIgnorePagesLoading(false);
    });
  };

  const handleIgnorePagesChange = (value) => {
    setIgnorePagesValue(value);
  };

  const handleSaveIgnorePages = (e) => {
    e.preventDefault();
    FunnelApi.saveignorepages({
      system_website_id: selectedMemberWebsite,
      page_id:ignorePagesId,
      ignore_page_id:ignorePagesValue
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setIgnorePagesModalOpen(false);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }
  
  const handleIgnorePagesCloseModal = () => {
    setIgnorePagesModalOpen(false);
  };
/* END IGNORE PAGES */
  return (
    <>
    <VisiLoader VisiLoaderVisible={SystemUsageLoader}/>
    <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
    {showHelpModal && Object.keys(tooltipPosition).map((key) => (
      ReactDOM.createPortal(
        <div>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition[key]}
          />
        </div>,
      document.body
    )))}
    <AddButtonToFunnel handleAddbuttonFunnelOpenModalProp={handleAddbuttonFunnelOpenModalProp} selectedMemberWebsite={selectedMemberWebsite} setUpdatedtime={setUpdatedtime} setSelectedPageId={setSelectedPageId} selectedPageId={selectedPageId} sethandleAddbuttonFunnelOpenModalProp={sethandleAddbuttonFunnelOpenModalProp}/>
    <BlockIP handleBlockIPOpenModalProp={handleBlockIPOpenModalProp}  sethandleBlockIPOpenModalProp={sethandleBlockIPOpenModalProp} selectedMemberWebsite={selectedMemberWebsite}/>
    {/*Edit Page*/}
    {editPageModalOpen && (
    <Modal.Root opened={true} onClose={handleEditPageCloseModal} style={{ zIndex: 2 }} trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>EDIT PAGE <IconHelp ref={editPageRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(195)}/></Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={form.onSubmit((formData) => { handleEditPageSubmit(formData); })}>
            <Input.Wrapper label="Name" error={form.errors.name}>
              <Input name="name" value={editPageDetail.name} onChange={handleChangeEditPage} error={form.errors.name && 'Page is Required field'}/>
            </Input.Wrapper>
            <Input.Wrapper label="URL" error={form.errors.url}>
              <Input name="url" value={editPageDetail.url} onChange={handleChangeEditPage} error={form.errors.url && 'URL is Required field'}/>
            </Input.Wrapper>
            <Group position="right">
              <Button type="submit" size="sm" w={80} mt={25}>
                Save
              </Button>
            </Group>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
    )}
    {/*Universal Smart Code*/}
    <UniversalSmartCodeModal
      opened={visiSmartCodeModalOpen}
      onClose={handleVisiSmartCodeCloseModal}
      websiteId={selectedMemberWebsite}
      websiteUrl={(websiteListData || []).find((w:any) => String(w.website_id) === String(selectedMemberWebsite))?.website_url || ''}
      subdomainVisiSmartCode={false}
      visiSmartCodeSubdomainId={''}
      showAdvancedTracking={false}
      pageId={visiSmartCodePageId}
    />
    {/*setting*/}
    <Modal.Root opened={settingModalOpen} onClose={handleSettingCloseModal} trapFocus={false} style={{ zIndex: 2 }}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>SETTING <IconHelp ref={settingsIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(327)}/></Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={form.onSubmit((formData) => { handleSavePageTimeoutSubmit(formData); })}>
            <Input.Wrapper label="Set Page Delay Timeout (in milliseconds)" error={form.errors.savepagetimeout}>
              <Input id="savepagetimeout" type="number" name="savepagetimeout" value={settingdata.savepagetimeout} hidden={PageTimeout ? true : false} onChange={handleChangePageTime}/>
            </Input.Wrapper>        
            <Input.Wrapper label="Flicker Control (in milliseconds)" error={form.errors.saveflickercontrol}>
              <Input id="saveflickercontrol" type="number" name="saveflickercontrol" value={settingdata.saveflickercontrol} hidden={FlickerControl ? true : false} onChange={handleChangeFlickerControl}/>
            </Input.Wrapper>
            <Space w="xs" />
            <Group position="right">
              <Button type="submit" size="sm" w={80} mt={25}>
                Save
              </Button>
            </Group>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
    {/*Ignore Pages Model*/}
    <Modal.Root opened={ignorePagesModalOpen} onClose={handleIgnorePagesCloseModal} size="60%" trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>IGNORE PAGES <IconHelp ref={ignorePageRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(349)}/></Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSaveIgnorePages}>
            <Group spacing="xs" mb={5} align="flex-start">
              <Text mr={17} weight={500} mt={6}>Select Pages:</Text>
              {ignorePagesLoading ? (
                <Flex direction="column" gap="xs" w={500}>
                  <Skeleton height={22} width="100%" radius="sm" />
                  <Skeleton height={22} width="100%" radius="sm" />
                </Flex>
              ) : (
              <MultiSelect
                data={ignorePagesList.map(option => ({
                  value: option.page_id,
                  label: option.page_url
                }))}
                value={ignorePagesValue}
                onChange={handleIgnorePagesChange}
                name="ignore_page"
                w={500}
                placeholder="Select Pages"
                searchable
                withinPortal
                valueComponent={forwardRef<HTMLDivElement, any>(({ value, label, onRemove, ...others }, ref) => (
                  <div ref={ref} {...others} style={{ maxWidth: '100%' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: isDarkMode ? theme.colors.dark[5] : '#fff',
                      border: `1px solid ${isDarkMode ? theme.colors.dark[3] : '#ced4da'}`,
                      paddingLeft: 10,
                      paddingRight: 2,
                      borderRadius: 4,
                      height: 22,
                      maxWidth: '100%',
                    }}>
                      <span style={{
                        fontSize: 12,
                        lineHeight: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        minWidth: 0,
                        flex: 1,
                        color: isDarkMode ? theme.colors.dark[0] : '#000',
                      }} title={label}>{label}</span>
                      <ActionIcon
                        size={20}
                        ml={4}
                        variant="transparent"
                        tabIndex={-1}
                        style={{ flexShrink: 0 }}
                        onMouseDown={onRemove}
                      >
                        <IconX size={12} />
                      </ActionIcon>
                    </div>
                  </div>
                ))}
              />
              )}
            </Group>
            <Group position="right">
              <Button type="submit" size="sm" w={80} mt={25}>
                Save
              </Button>
            </Group>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>

    {/*Merge Pages*/}
    <Modal.Root opened={mergePageModalOpen} onClose={handleMergePageCloseModal} size="60%" trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>MERGE PAGES <IconHelp ref={mergePageRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(115)}/></Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSaveMergePages}>
            <Group spacing="xs" mb={5} align="flex-start">
              <Text mr={17} weight={500} mt={6}>Select Pages:</Text>
              {mergePagesLoading ? (
                <Flex direction="column" gap="xs" w={500}>
                  <Skeleton height={22} width="100%" radius="sm" />
                  <Skeleton height={22} width="100%" radius="sm" />
                </Flex>
              ) : (
              <MultiSelect
                data={mergePagesList.map(option => ({
                  value: option.link_id,
                  label: option.page_url
                }))}
                value={mergePagesValue}
                onChange={handleMergePagesChange}
                name="merge_page"
                placeholder="Select Pages"
                w={500}
                searchable
                withinPortal
                valueComponent={forwardRef<HTMLDivElement, any>(({ value, label, onRemove, ...others }, ref) => {
                  const decodeHtml = (str: string) => {
                    const txt = document.createElement('textarea');
                    txt.innerHTML = str ?? '';
                    return txt.value;
                  };
                  const isLocked = mergeOriginUrl !== '' && decodeHtml(label) === decodeHtml(mergeOriginUrl);
                  return (
                    <div ref={ref} {...others} style={{ maxWidth: '100%' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: isDarkMode ? theme.colors.dark[5] : '#fff',
                        border: `1px solid ${isDarkMode ? theme.colors.dark[3] : '#ced4da'}`,
                        paddingLeft: 10,
                        paddingRight: isLocked ? 10 : 2,
                        borderRadius: 4,
                        height: 22,
                        maxWidth: '100%',
                      }}>
                        <span style={{
                          fontSize: 12,
                          lineHeight: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          minWidth: 0,
                          flex: 1,
                          color: isDarkMode ? theme.colors.dark[0] : '#000',
                        }} title={label}>{label}</span>
                        {!isLocked && (
                          <ActionIcon
                            size={20}
                            ml={4}
                            variant="transparent"
                            tabIndex={-1}
                            style={{ flexShrink: 0 }}
                            onMouseDown={onRemove}
                          >
                            <IconX size={12} />
                          </ActionIcon>
                        )}
                      </div>
                    </div>
                  );
                })}
              />
              )}
            </Group>
            <Group position="right">
              <Button type="submit" size="sm" w={80} mt={25}>
                Save
              </Button>
            </Group>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
    {/*Edit Title*/}
    <Modal.Root opened={editTitleModelOpen} onClose={handleEditTitleCloseModal} trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>EDIT TITLE <IconHelp ref={editTitleRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(194)}/></Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={form.onSubmit((formData) => { handleSaveCustomTitleSubmit(formData, selectedPageId); })}>
            <div style={{ display: 'flex'}}>
              <Input.Wrapper label="Name" error={form.errors.name}>
                <Input name="name" value={customtitle.name} onChange={handleChangeCustomTitle} error={form.errors.name && 'Title is Required field'} w={315}/>
              </Input.Wrapper>
              <Space w="xs" />          
              <Button type="submit" size="sm" w={80} mt={25}>
                Save
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
    {/*Check Tracking Model*/}
    {checkTrackingModelOpen && (
    <Modal.Root opened={true} onClose={handleCheckTrackingCloseModal} style={{ zIndex: 2 }} trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>CHECK TRACKING</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form>
            <div style={{ display: 'flex'}}>
                <Text weight={500}>{checkTracking}</Text>
            </div>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
    )}
    <AddFunnelPage handleSelectPageOpenModalProp={handleSelectPageOpenModalProp} sethandleSelectPageOpenModalProp={sethandleSelectPageOpenModalProp} setSystemUsageLoader={setSystemUsageLoader} selectedMemberWebsite={selectedMemberWebsite} setLoading={setLoading} marksalestime={marksalestime} resetSelection={resetSelection} setMarksalestime={setMarksalestime} loading={loading} selectedThumbnails={selectedThumbnails} setSelectedThumbnails={setSelectedThumbnails} setVisiSmartCodeModalOpen={setVisiSmartCodeModalOpen} setVisiSmartCodePageId={setVisiSmartCodePageId} handleRemoveFromfunnel={handleRemoveFromfunnel} handleCheckTrecking={handleCheckTrecking} handleEditOpenModal={handleEditOpenModal} handleDeletePage={handleDeletePage} setSelectedPageId={setSelectedPageId} setAfterAddNewPage={setAfterAddNewPage}/>
    <Container size="auto">
      <Card shadow="sm" padding="sm" radius="md" withBorder>
        <Group position="apart" mb="xs">
          <Text weight={500}>FUNNELS  <IconHelp ref={funnelsIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(5)}/></Text>
        </Group>
        <Group spacing="xs" mb={10} mt={20}>
          <Text size="sm" fz={12} fw={500} maw={150}>Select Funnel:</Text>
          <SelectFunnelList updated_time={updatedtime} Value={SelectedFunnelValue} OnChange={handleSelectFunnelListComponentChange} MemberWebsiteId={selectedMemberWebsite} Width={180}/>
          <PermissionWrapper permission="operational_access">
            <Menu width={210} position="bottom-start">
              <Menu.Target>
                <ActionIcon variant="default" size="lg" title="Settings"><IconSettings size="1rem"/></ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                {SelectedFunnelValue !== '' && (<Menu.Item px={10} py={6} onClick={() => handleEditFunnelOpenModal(1)}>Rename the Funnel</Menu.Item>)}
                {SelectedFunnelValue && (<Menu.Item px={10} py={6} onClick={() => setDuplicateFunnelModalOpen(true)}>Duplicate the Funnel</Menu.Item>)}
                <Menu.Item px={10} py={6} onClick={handleAddbuttonFunnelOpenModal}>Add Button to the Funnel</Menu.Item>
                <Menu.Item px={10} py={6} onClick={handleBlockIPOpenModal}>Block IP Address</Menu.Item>
                {SelectedFunnelValue !== '' && (<Menu.Item px={10} py={6} onClick={() => deleteFunnelConfirm(selectedMemberWebsite)}>Delete the Funnel</Menu.Item>)}
              </Menu.Dropdown>
            </Menu>
            <DuplicateFunnel duplicateFunnelModalOpen={duplicateFunnelModalOpen} setDuplicateFunnelModalOpen={setDuplicateFunnelModalOpen} selectedMemberWebsite={selectedMemberWebsite} SelectedFunnelValue={SelectedFunnelValue} setUpdatedtime={setUpdatedtime} handleSelectFunnelListComponentChange={handleSelectFunnelListComponentChange}/>
            <AddUpdateFunnel handleEditFunnelOpenModalProp={handleEditFunnelOpenModalProp} selectedMemberWebsite={selectedMemberWebsite} data={data} SelectedFunnelValue={SelectedFunnelValue} setUpdatedtime={setUpdatedtime} handleSelectFunnelListComponentChange={handleSelectFunnelListComponentChange} setselectedFunnelTitle={setselectedFunnelTitle} handleChange={handleChange} sethandleEditFunnelOpenModalProp={sethandleEditFunnelOpenModalProp}/>
          </PermissionWrapper>
        </Group>
        <FunnelData selectedFunnelTitle={selectedFunnelTitle} selectedMemberWebsite={selectedMemberWebsite} setLoading={setLoading} setselectedFunnelTitle={setselectedFunnelTitle} marksalestime={marksalestime} updatedtime={updatedtime} setSystemUsageLoader={setSystemUsageLoader} loading={loading} handleEditTitleOpenModal={handleEditTitleOpenModal} selectedOption={selectedOption} handleChooseActionChange={handleChooseActionChange} handleSelectPageOpenModal={handleSelectPageOpenModal} Avoidextracall={Avoidextracall} SelectedFunnelValue={SelectedFunnelValue} setMergeOriginUrl={setMergeOriginUrl}/>
        <FunnelLegend />
      </Card>
    </Container>
    </>
  );
}
